import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ByProducts37_3Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const ByProducts37_3 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("BY_PRODUCTS_INSTALLATION") || "By-products that arise from Installation and Construction"}
        subDescription={t("BY_PRODUCTS_37_3_DESC") || "Enter any surplus materials here that can be used as products in their own right or refined further into products. This includes by-products and other materials that are produced during the Installation and Construction process, such as heat, chemicals, enzymes, metal pieces and lower-grade chemicals."}
        isNormal={true}
        number={"37.3"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`by-products-37-3-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ByProducts37_3Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default ByProducts37_3;

